import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ColorService {
  baseURL = environment.backend_base_url;
  //baseURL = 'https://bsa-api.musea2.azure.ext.gm.com'; // Base URL for the backend
  private colorUpdated = new Subject<{gmid: string, color: string}>();

  constructor(
      public _http: HttpClient
    ) { } 
  
  // Observable for components to subscribe to color updates
  colorUpdated$ = this.colorUpdated.asObservable();

  // Method to emit color updates
  notifyColorUpdate(gmid: string, color: string): void {
    console.log(`ColorService: Notifying color update for ${gmid} to ${color}`);
    this.colorUpdated.next({ gmid, color });
  }

  /* Update user color preference
   * @param gmid - The ID of the user to update color for
   * @param color - The hex color value to set
   * @returns Observable containing the response from the backend
   */
  updateUserColor(gmid: string, color: string): Observable<any> {
    const url = `${this.baseURL}/api/admin/color/update`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = { gmid: gmid, color: color };
    return this._http.post<any>(url, body, { headers });
  }
}
